import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { CerFormComponent } from '../../cer/cer-form/cer-form.component';
import { CerGridComponent, CerGridEditSettings } from '../../cer/cer-grid/cer-grid.component';
import { FieldEditChangedArgs, FieldGroupMetadata, FieldMetadata, FieldWidthEnum, ViewMetadata } from '../../cer/cer-data/cer-data-types';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';
import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { ICerFormViewCustomComponent } from '@form/cer-form-view-type/icer-form-view-custom-component';
import { CerFormView } from '@form/cer-form-view';

@Component({
  selector: 'contract',
  templateUrl: './contract.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ContractComponent implements ICerFormViewCustomComponent {

  // View
  protected formView: CerFormView;
  public setView(view: CerFormView): void {
    this.formView = view;
  }

  public onViewCommand(e: UiCommandEvent): void {
    this.form?.formService.formCommandNext(e);
  }

  protected panesMain = CerFormPanesSettingsUtil.main();

  private form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(content: CerFormComponent) {
    if (content && !this.form) {
      this.form = content;
    }
  }

  private grid: CerGridComponent;
  @ViewChild('grid', { static: false }) set gridContent(content: CerGridComponent) {
    if (content && !this.grid) {
      this.grid = content;
    }
  }

  public editSettings : CerGridEditSettings = { mode: 'dialog', dialog: { width: '100%' } };
  public viewMetadata: ViewMetadata = {
    name: 'Kontrakter', dataApiName: 'Contract', text: 'Kontrakter (rediger)', textSingular: 'Kontrakt (rediger)',
    primaryKey: 'num', baseFields: ['num', 'name', 'history']
  };

  public fieldGroupMetadata: FieldGroupMetadata[] = [
    { idx: 1, name: 'identification', text: 'Identifikation', fields: ['num', 'name'] },
    { idx: 2, name: 'setup', text: 'Opsætning', fields: ['type', 'currency', 'responsible', 'closed'] },
    { idx: 3, name: 'references', text: 'Referencer', fields: ['conterParty', 'agentParty'] },
  ];

  public fieldMetadata: FieldMetadata[] =
    [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', widthType: FieldWidthEnum.XS, visible: false },
    { name: 'num', text: 'Kontrakt', tooltipText: 'Kontraktnummer', widthType: FieldWidthEnum.XXL, visibleAdd: false, allowEdit: false, filterOperator: 'startswith', orderBy: 'Descending' },
    { name: 'name', text: 'Titel', tooltipText: 'Titel', widthType: FieldWidthEnum.XXL },
    { name: 'type', text: 'Aftaletype', tooltipText: 'Aftalens type', widthType: FieldWidthEnum.S, foreignKeyTableName: 'ContractType', foreignKeyField: 'num', foreignKeyValue: 'name', foreignKeySortFields: ['sorting'], onEditChanged: (args) => { this.editChangedType(args) } },
    { fieldType: 'currency', text: 'Aftalevaluta', tooltipText: 'Aftalens valuta' },
    { name: 'responsible', text: 'Redaktør', tooltipText: 'Redaktørnavn', widthType: FieldWidthEnum.XS, foreignKeyTableName: 'User', foreignKeyField: 'id', foreignKeyValue: 'shortName', required: true },
    { name: 'counterParty', text: 'Modpart', tooltipText: 'Hvem er kontrakten indgået med', foreignKeyTableName: 'Forfatter', foreignKeyField: 'forfatterId', foreignKeyValue: 'navn', widthType: FieldWidthEnum.S },
    { name: 'agentParty', text: 'Agent', tooltipText: 'Hvem er agent på kontrakten', foreignKeyTableName: 'Forfatter', foreignKeyField: 'forfatterId', foreignKeyValue: 'navn', widthType: FieldWidthEnum.S },
    { name: 'legacyId', text: 'Opr. id', format: 'Integer', visible: false },
    { name: 'closed', text: 'Lukket dato', format: 'DateShort', visible: false }
    ];

  public toolbarCommands: UiCommand[] = [];
  public contextMenuCommands: UiCommand[] = [];

  constructor(session: CerSessionService) {
    this.fieldMetadata.find(f => f.name == 'responsible').defaultValue = session.user.id();
  }

  protected onCommand($event: UiCommandEvent) {
  }

  private editChangedType(args: FieldEditChangedArgs) {
  }

}

